<form class="form"
      [formGroup]="webForm"
      (ngSubmit)="submit()">

  @if (defaults()?.url || loadingDefaults().length) {
    <span></span>
    <div>
      <span i18n>Loading defaults for <app-nav [url]="defaults()?.url || ('tag:/' + loadingDefaults()[0].tag)" /></span>
      @if (!defaults()) {
        <app-loading [inline]="true" />
      }
    </div>
  }

  <app-ref-form #refForm [group]="webForm"
                [creating]="true"
                (toggleTag)="bookmarks.toggleTag($event)" />

  @for (e of serverError(); track e) {
    <span><!-- Unexpected Error --></span>
    <div class="error">{{ e }}</div>
  }
  <span><!-- Buttons --></span>
  <span class="buttons right floating">
    @if (submitting() || saving()) {
      <app-loading [inline]="true" />
    }
    @if (admin.getPlugin('plugin/editing')) {
      <button type="button" [disabled]="submitting() || saving() || submitted() || webFormPristine()" (click)="saveForLater(true)" i18n>Save for later</button>
    }
    @if (alreadyExists()) {
      <button type="button" [disabled]="submitting() || saving()" (click)="prepareRepost()" i18n>Repost</button>
    }
    <button type="submit" [disabled]="!defaultsLoaded() || submitting() || alreadyExists() || (submitted() && !webFormValid())" i18n>Submit</button>
  </span>
</form>
